<template>
  <div>
    <v-expansion-panel popout>
      <v-expansion-panel-content>
        <div slot="header"><b>Items</b></div>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs8>
                <v-text-field append-icon="search"
                              label="Search"
                              single-line
                              hide-details
                              v-model="ItemsSearch"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-tooltip bottom>
                  <v-btn v-on:click.prevent="addItem = true"
                         slot="activator"
                         small
                         fab
                         middle
                         right
                         style="float:right;">
                    <v-icon>fas fa-plus</v-icon>
                  </v-btn>
                  <span>Add Item</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <v-flex xs12 md6 lg4>
              <v-card style="width: 100%;margin-bottom: 1px;" :class="{'dark-mode':$store.state.NightMode.sideNav == 'dark-mode','light-mode':$store.state.NightMode.sideNav == 'light-mode'}">
                <v-container fluid style="padding: 10px;">

                  <v-card-text style="padding: 2px;">
                    <v-layout v-for="item in items" :key="item.id" wrap>
                      <v-flex xs6 v-on:click.prevent="item.show = !item.show">
                        <div>{{item.itemName}}</div>
                      </v-flex>
                      <v-flex xs6 v-on:click.prevent="item.show = !item.show">
                        <span>{{ item.itemPrice }} {{ item.itemCurrency }}</span>
                      </v-flex>
                      <v-flex xs12 v-show="item.show">
                        <v-slide-y-transition>
                          <v-card>
                            <v-card-text>
                              <v-layout row wrap>
                                <v-toolbar flat style="width:170px;margin-left: auto;margin-right: auto;border-radius: 28px;">
                                  <v-btn icon class="mx-0" v-on:click.prevent="editItem(item.id)" style="margin-left: 15px !important;">
                                    <v-icon color="teal">edit</v-icon>
                                  </v-btn>
                                  <v-spacer></v-spacer>
                                  <v-btn icon class="mx-0" v-on:click.prevent="deleteItem(item)" style="margin-right: 15px !important;">
                                    <v-icon color="error">delete</v-icon>
                                  </v-btn>
                                </v-toolbar>
                                <v-flex xs12 v-if="item.taxedPrice !== '' && item.taxedPrice !== 0">Total With Tax: {{ item.taxedPrice }}</v-flex>

                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-slide-y-transition>
                      </v-flex>
                      <v-divider></v-divider>
                    </v-layout>
                  </v-card-text>
                </v-container>
              </v-card>
            </v-flex>

          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--Add Item-->
    <v-layout row justify-center>
      <v-dialog v-model="addItem" persistent scrollable max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">New Item</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="addItemCheck($v.ItemTemp)">
              <v-icon color="green">fas fa-check</v-icon>
            </v-btn>
            <v-btn icon @click.native="addItem = false">
              <v-icon color="red">fas fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>

                  <v-combobox v-model="ItemTemp.itemName"
                              :items="ItemsNames"
                              chips
                              label="Item Name"></v-combobox>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Item Price" type="number" min="1"
                                v-model="ItemTemp.itemPrice"
                                :error-messages="ItemPriceErrors"
                                @input="$v.ItemTemp.itemPrice.$touch()"
                                @blur="$v.ItemTemp.itemPrice.$touch()"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select v-bind:items="curriencies"
                            label="Currency"
                            v-model="ItemTemp.itemCurrency"
                            single-line
                            :error-messages="ItemCurrencyErrors"
                            @input="$v.ItemTemp.itemCurrency.$touch()"
                            @blur="$v.ItemTemp.itemCurrency.$touch()"></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox label="Add Tax to item?"
                              v-model="ItemTemp.isTaxed"></v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="ItemTemp.isTaxed">
                  <v-text-field label="Total WIth Tax" type="number"
                                v-model="ItemTemp.taxedPrice"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

        </v-card>
      </v-dialog>
    </v-layout>
    <!--End Of Add Item-->

    <!--Edit Item-->
    <v-layout row justify-center>
      <v-dialog v-model="editItems" persistent scrollable max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Item</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="editItemCheck($v.editItemTemp)">
              <v-icon color="green">fas fa-check</v-icon>
            </v-btn>
            <v-btn icon @click.native="editItems = false">
              <v-icon color="red">fas fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>

                  <v-combobox v-model="editItemTemp.itemName"
                              :items="ItemsNames"
                              chips
                              label="Item Name"></v-combobox>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Item Price" type="number" min="1"
                                v-model="editItemTemp.itemPrice"
                                :error-messages="ItemPriceErrors"
                                @input="$v.editItemTemp.itemPrice.$touch()"
                                @blur="$v.editItemTemp.itemPrice.$touch()"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select v-bind:items="curriencies"
                            label="Currency"
                            v-model="editItemTemp.itemCurrency"
                            single-line
                            :error-messages="ItemCurrencyErrors"
                            @input="$v.editItemTemp.itemCurrency.$touch()"
                            @blur="$v.editItemTemp.itemCurrency.$touch()"></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox label="Add Tax to item?"
                              v-model="editItemTemp.isTaxed"></v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="editItemTemp.isTaxed">
                  <v-text-field label="Total WIth Tax" type="number"
                                v-model="editItemTemp.taxedPrice"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

        </v-card>
      </v-dialog>
    </v-layout>
    <!--End Of edit Item-->

    <!--Delete Item-->
    <v-layout row justify-center>
      <v-dialog v-model="deleteDialog" max-width="290">
        <v-card>
          <v-card-title class="headline">Delete</v-card-title>
          <v-card-text>Are you sure you want to delete <b>"{{deleteItemTemp.itemName}}"</b>?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="deleteDialog = false">No</v-btn>
            <v-btn color="green darken-1" flat="flat" @click.native="deleteItemAccept()">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!--End Of Delete Item-->

  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'

  import { globalFunctions } from '../../../javascript/globalFunctions'

  export default {
    mixins: [validationMixin],
    props: ["itype"],
    data() {
      return {
        curriencies: ["USD", "JMD"],
        addItem: false,
        editItems: false,
        deleteDialog: false,
        Itemheaders: [
          { text: 'Item', align: 'left', value: 'itemName' },
          { text: 'Price', align: 'left', value: 'itemPrice' }
        ],
        ItemsNames: ['Cat', 'Dog'],
        ItemsSearch: '',
        ItemTemp: {
          id: 0,
          itemName: '',
          itemPrice: '',  
          itemCurrency: '',
          isTaxed: false,
          taxedPrice: '',

          dateChanged: '',

          objectState: 'New',
          show: false
        },
        editItemTemp: {
          id: 0,
          itemName: '',
          itemPrice: '',
          itemCurrency: '',
          isTaxed: false,
          taxedPrice: '',

          dateChanged: '',

          objectState: '',
          show: false
        },
        deleteItemTemp: {
          id: 0,
          itemName: '',
          itemPrice: '',
          itemCurrency: '',
          isTaxed: false,
          taxedPrice: '',

          dateChanged: '',

          objectState: '',
          show: false
        },
        items: [],
        storedItems: []
      }
    },
    computed: {
      ItemNameErrors() {
        const errors = []
        if (!this.$v.ItemTemp.itemName.$dirty || !this.$v.editItemTemp.itemName.$dirty) return errors
        !this.$v.ItemTemp.itemName.required && !this.$v.editItemTemp.itemName.required && errors.push('Item Name is required')
        return errors
      },
      ItemPriceErrors() {
        const errors = []
        if (!this.$v.ItemTemp.itemPrice.$dirty || !this.$v.editItemTemp.itemPrice.$dirty) return errors
        !this.$v.ItemTemp.itemPrice.minValue && !this.$v.editItemTemp.itemPrice.minValue && errors.push('Item Price must be at least 1')
        return errors
      },
      ItemCurrencyErrors() {
        const errors = []
        if (!this.$v.ItemTemp.itemCurrency.$dirty || !this.$v.editItemTemp.itemCurrency.$dirty) return errors
        !this.$v.ItemTemp.itemCurrency.required && !this.$v.editItemTemp.itemCurrency.required && errors.push('Currency is required')
        return errors
      }
    },
    methods: {
      itemCheck: function ($v) {
        $v.$touch(); //Triggers Error Messages

        if (this.ItemTemp.itemPrice < 0 || !globalFunctions.isIntOrFloat(this.ItemTemp.itemPrice) || this.ItemTemp.itemPrice === "") { this.ItemTemp.itemPrice = 0 }

        if ($v.itemName.$invalid || $v.itemPrice.$invalid || $v.itemCurrency.$invalid) {
          return false
        }
        return true
      },
      addItemCheck: function ($v) {
        if (this.itemCheck($v)) {
          this.addItemToItems()

          $v.$reset()
        }
      },
      addItemToItems: function () {
        //Add Item to Transaction Items

        let newItem = JSON.parse(JSON.stringify(this.ItemTemp))

        newItem.id = this.getLargestIdFromItems() + 1

        this.returnItem(newItem)
        this.items.push(newItem)

        this.addItem = false

        this.doesItemExist()

        this.resetItemForm()
      },
      getLargestIdFromItems() {
        let largest = 0
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id > largest) {
            largest = this.items[i].id
          }
        }
        return largest
      },
      resetItemForm: function () {
        this.ItemTemp.itemName = ''
        this.ItemTemp.itemPrice = 0
        this.ItemTemp.itemCurrency = ''
        this.ItemTemp.isTaxed = false
        this.ItemTemp.taxedPrice = 0
      },
      doesItemExist: function () {
        if (this.items.length !== 0) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].itemName === this.ItemTemp.itemName) {

              /////////////////////////////////////////////////////////////
              //Check All other values to see if they are the same
              /////////////////////////////////////////////////////////////

              if (this.items[i].itemPrice !== this.ItemTemp.itemPrice) {

                ///////////////////////////////////////////////////////////////////
                //Create New Item To Represent Update,
                //Keep Old Data As To Not Cause Problems To Past Transactions
                ///////////////////////////////////////////////////////////////////

                this.addNewItem()
                return
              }

            }
          }
        }
        else {
          this.addNewItem()
        }

      },
      addNewItem: function () {
        this.ItemTemp.dateChanged = globalFunctions.getCurrentDate()

        let newEntry = JSON.parse(JSON.stringify(this.ItemTemp))

        newEntry.id = this.getLargestIdFromItems() + 1

        this.$store.commit('addNewItemToStore', newEntry)
      },
      getLargestIdFromItems: function () {
        let largest = 0
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id > largest) {
            largest = this.items[i].id
          }
        }
        return largest
      },
      returnItem: function (item) {
        this.$emit('ItemToAdd', item)
      },
      editItem: function (item) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === parseInt(item)) {
            let editEntry = JSON.parse(JSON.stringify(this.items[i]))
            this.editItemTemp = editEntry
            break
          }
        }

        this.editItems = true
      },
      editItemCheck: function ($v) {
        if (this.itemCheck($v)) {
          this.editItemTemp.objectState = "Update"

          this.$store.commit('updateIteminStore', this.editItemTemp)

          this.updateItemList()

          this.editItems = false

          this.returnItem(this.editItemTemp)
        }
      },
      updateItemList: function () {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === this.editItemTemp.id) {
            this.items[i] = JSON.parse(JSON.stringify(this.editItemTemp))
          }
        }
      },
      deleteItem: function (item) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i] === item) {
            this.deleteItemTemp = this.items[i]
            break
          }
        }

        this.deleteDialog = true
      },
      deleteItemAccept: function () {

      }
    },
    beforeMount() {

    },
    validations: {
      ItemTemp: {
        itemName: {
          required
        },
        itemPrice: {
          required,
          minValue: minValue(1)
        },
        itemCurrency: {
          required
        }

      },
      editItemTemp: {
        itemName: {
          required
        },
        itemPrice: {
          required,
          minValue: minValue(1)
        },
        itemCurrency: {
          required
        }

      }
    }

  }
</script>

<style scoped>
  .v-divider {
    flex-basis: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reuseable/items/Items.vue